import alert from './alert';
import avatar from './avatar';
import { breakpoints } from './breakpoint';
import buttons from './buttons';
import checkbox from './checkbox';
import clearButtons from './clearButtons';
import countDot from './countDot';
import iconButton from './iconButton';
import inputs from './inputs';
import colors from './colors';
import fonts from './fonts';
import tabs from './tabs';
import tag from './tag';
import textButtons from './textButtons';
import toggle from './toggle';
import toast from './toast';
import zIndex from './zIndex';
import imagePreview from './imagePreview';
import tooltip from './tooltip';
import lineChart from './lineChart';
import messageBubble from './messageBubble';
import dynamicEditor from './dynamicEditor';
import showImage from './showImage';
const theme = {
    alert,
    avatar,
    breakpoints,
    buttons,
    checkbox,
    clearButtons,
    countDot,
    colors,
    dynamicEditor,
    dimensions: {
        desktop: {
            verticalGutter: 8,
            horizontalGutter: 8,
        },
        tablet: {
            verticalGutter: 8,
            horizontalGutter: 8,
        },
        mobile: {
            verticalGutter: 8,
            horizontalGutter: 0,
        },
    },
    fonts,
    iconButton,
    icons: {
        size: {
            XXSMALL: '0.75rem',
            XSMALL: '0.875rem',
            SMALL: '1rem',
            MEDIUM: '1.25rem',
            LARGE: '1.5rem',
            XLARGE: '1.75rem',
            XXLARGE: '2rem',
        },
    },
    inputs,
    name: 'Admin',
    tabs,
    textButtons,
    toast,
    toggle,
    zIndex,
    imagePreview,
    tooltip,
    lineChart,
    messageBubble,
    tag,
    showImage,
};
export default theme;
//# sourceMappingURL=index.js.map